import * as React from "react";
import { SVGProps } from "react";

const Bank: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.23056 5.94656L3.23183 5.94605L12.9797 2.04691C12.98 2.04679 12.9804 2.04666 12.9807 2.04653C13.2741 1.9311 13.7266 1.9311 14.02 2.04653C14.0203 2.04666 14.0206 2.04679 14.0209 2.04691L23.7688 5.94605L23.7701 5.94656C24.2609 6.14132 24.6462 6.71464 24.6462 7.2368V10.8335C24.6462 11.5973 24.0142 12.2293 23.2503 12.2293H3.75033C2.98647 12.2293 2.35449 11.5973 2.35449 10.8335V7.2368C2.35449 6.70542 2.73825 6.14192 3.23056 5.94656ZM3.46692 6.52349L3.4477 6.53119L3.42919 6.54045C3.28681 6.61164 3.18566 6.73506 3.13642 6.80326C3.10439 6.84761 3.07063 6.90161 3.04289 6.96215C3.01932 7.01359 2.97949 7.11324 2.97949 7.2368V10.8335C2.97949 11.2613 3.32252 11.6043 3.75033 11.6043H23.2503C23.6781 11.6043 24.0212 11.2613 24.0212 10.8335V7.2368C24.0212 7.12291 23.9879 7.02915 23.9652 6.97545C23.9393 6.91433 23.9068 6.85855 23.8736 6.8108C23.8219 6.73634 23.7124 6.59991 23.5448 6.52809L23.5449 6.52795L23.5336 6.52342L13.7929 2.6271C13.7088 2.59084 13.6338 2.58279 13.5983 2.57986C13.5604 2.57674 13.5219 2.5768 13.5044 2.57684C13.5029 2.57684 13.5015 2.57684 13.5003 2.57684L13.4964 2.57684C13.4778 2.57682 13.44 2.57678 13.4028 2.57941L13.4008 2.57955C13.3759 2.58128 13.2913 2.58717 13.1988 2.62639L3.46692 6.52349Z"
      fill="#1A1C1F"
      stroke="#1A1C1F"
    />
    <path
      d="M2.97949 23.0208V23.5208H3.47949H23.5212H24.0212V23.0208V20.5833C24.0212 20.1555 23.6781 19.8125 23.2503 19.8125H3.75033C3.32252 19.8125 2.97949 20.1555 2.97949 20.5833V23.0208ZM24.3337 24.1458H2.66699C2.49897 24.1458 2.35449 24.0014 2.35449 23.8333V20.5833C2.35449 19.8195 2.98647 19.1875 3.75033 19.1875H23.2503C24.0142 19.1875 24.6462 19.8195 24.6462 20.5833V23.8333C24.6462 24.0014 24.5017 24.1458 24.3337 24.1458Z"
      fill="#1A1C1F"
      stroke="#1A1C1F"
    />
    <path
      d="M4.83301 20.3128C4.38884 20.3128 4.02051 19.9445 4.02051 19.5003V11.917C4.02051 11.4728 4.38884 11.1045 4.83301 11.1045C5.27717 11.1045 5.64551 11.4728 5.64551 11.917V19.5003C5.64551 19.9445 5.27717 20.3128 4.83301 20.3128Z"
      fill="#1A1C1F"
    />
    <path
      d="M9.16699 20.3128C8.72283 20.3128 8.35449 19.9445 8.35449 19.5003V11.917C8.35449 11.4728 8.72283 11.1045 9.16699 11.1045C9.61116 11.1045 9.97949 11.4728 9.97949 11.917V19.5003C9.97949 19.9445 9.61116 20.3128 9.16699 20.3128Z"
      fill="#1A1C1F"
    />
    <path
      d="M13.5 20.3128C13.0558 20.3128 12.6875 19.9445 12.6875 19.5003V11.917C12.6875 11.4728 13.0558 11.1045 13.5 11.1045C13.9442 11.1045 14.3125 11.4728 14.3125 11.917V19.5003C14.3125 19.9445 13.9442 20.3128 13.5 20.3128Z"
      fill="#1A1C1F"
    />
    <path
      d="M17.833 20.3128C17.3888 20.3128 17.0205 19.9445 17.0205 19.5003V11.917C17.0205 11.4728 17.3888 11.1045 17.833 11.1045C18.2772 11.1045 18.6455 11.4728 18.6455 11.917V19.5003C18.6455 19.9445 18.2772 20.3128 17.833 20.3128Z"
      fill="#1A1C1F"
    />
    <path
      d="M22.167 20.3128C21.7228 20.3128 21.3545 19.9445 21.3545 19.5003V11.917C21.3545 11.4728 21.7228 11.1045 22.167 11.1045C22.6112 11.1045 22.9795 11.4728 22.9795 11.917V19.5003C22.9795 19.9445 22.6112 20.3128 22.167 20.3128Z"
      fill="#1A1C1F"
    />
    <path
      d="M25.4163 24.6465H1.58301C1.13884 24.6465 0.770508 24.2782 0.770508 23.834C0.770508 23.3898 1.13884 23.0215 1.58301 23.0215H25.4163C25.8605 23.0215 26.2288 23.3898 26.2288 23.834C26.2288 24.2782 25.8605 24.6465 25.4163 24.6465Z"
      fill="#1A1C1F"
    />
    <path
      d="M13.5 10.0205C12.1567 10.0205 11.0625 8.92634 11.0625 7.58301C11.0625 6.23967 12.1567 5.14551 13.5 5.14551C14.8433 5.14551 15.9375 6.23967 15.9375 7.58301C15.9375 8.92634 14.8433 10.0205 13.5 10.0205ZM13.5 6.77051C13.0558 6.77051 12.6875 7.13884 12.6875 7.58301C12.6875 8.02717 13.0558 8.39551 13.5 8.39551C13.9442 8.39551 14.3125 8.02717 14.3125 7.58301C14.3125 7.13884 13.9442 6.77051 13.5 6.77051Z"
      fill="#1A1C1F"
    />
  </svg>
);

export default Bank;
